import {uploadTypes} from '../../action-types';

const {SET_UPLOAD_LIST, SET_UPLOAD_DETAIL, SET_UPLOAD_LIST_TOTAL, SET_UPLOAD_DETAIL_TOTAL} = uploadTypes;

const initialState = {
  listUpload: [],
  detailUpload: {},
  totalUpload: '',
  totalDetailUpload: 0,
};

const reducer = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case SET_UPLOAD_LIST:
      return {...state, listUpload: payload};
    case SET_UPLOAD_DETAIL:
      return {...state, detailUpload: payload};
    case SET_UPLOAD_LIST_TOTAL:
      return {...state, totalUpload: payload};
    case SET_UPLOAD_DETAIL_TOTAL:
      return {...state, totalDetailUpload: payload};
    default:
      return state;
  }
};

export default reducer;
